import { useStore} from 'vuex'
import { ref, onMounted } from 'vue'
import { post } from "foundation/js/api"

export default {
    name: 'HeroSectionCancerforum',
    props: {
        groupId: {
            type: String,
            required: true
        },
        isLoggedIn: {
            type: Boolean,
            required: true
        },
        isClosedGroup: {
            type: Boolean,
            required: true
        },
        isUserAwaitingAccess: {
            type: Boolean,
            required: true
        },
        loginUrl: {
            type: String,
            required: true
        },
    },
    setup(props) {
        const store = useStore()

        const isSubmitting = ref(false)
        const buttonText = ref('')

        const handleClick = async function (e) {
            if (!props.isLoggedIn) {
                window.location.href = props.loginUrl
                return
            }
            
            if (props.isClosedGroup) {
                store.dispatch('main/openPageOverlay', {
                    overlayContent: "ClosedGroupOverlay",
                    returnTarget: e.currentTarget
                })
                return
            }

            isSubmitting.value = true

            const url = `${document.location.origin}/${process.env.FORUM_JOIN_GROUP}`.replace('[groupId]', props.groupId)   
            await post(url, null)

            isSubmitting.value = false
            window.location.reload()
        }

        onMounted(() => {
            buttonText.value = getInitialButtonText()
        })

        const getInitialButtonText = () => {
            const labelKey = props.isUserAwaitingAccess 
                ? "ctaButtonLabelAwaitingAccess"
                : "ctaButtonLabelNotMember"

            return getLabel(labelKey)
        }

        const getLabel = function(labelKey) {
            return store.getters['labels/getLabel']({
                labelCollection: 'HeroSectionCancerforum',
                labelKey
            })
        }

        return {
            handleClick,
            getLabel,
            buttonText,
            isSubmitting,
        }
    }
}
